import { ServiceContext } from 'utilities/service.utils';

const IdentityService = new ServiceContext(
  process.env.REACT_APP_IDENTITY_API_URL,
  {
    withCredentials: true
  }
);

export default IdentityService;
